import { makeStyles } from '@material-ui/core/styles'

const COLOR = {
  produced: '#2768F6',
  consumed: '#F09035',
  imported: '#CD4425',
  exported: '#CD4425',
  charge: '#3A845D'
}

const useStyles = makeStyles(theme => ({
  cardWrapper: {
    margin: '24px 40px',
    padding: '20px'
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '40px 40px 24px',
    flexWrap: 'wrap'
  },
  currentStatus: {
    fontSize: '14px',
    backgroundColor: '#F7F7F7',
    color: '#6F6F6F',
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    marginBottom: '10px',
    marginTop: "12px",
    padding: '0 15px'
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px',
    display: 'flex',
    flexWrap: 'wrap'
  },
  switchContainer: {
    color: '#6F6F6F',
    fontSize: '14px',
    margin: '10px',
    backgroundColor: '#F7F7F7',
    borderRadius: '20px',
    padding: '0 15px'
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  titleWrapper: {
    margin: '30px 40px 24px'
  },
  createWrapper: {
    padding: '6px 32px 32px',
    margin: '0px 40px',
  },
  formWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '40%'
  },
  field: {
    marginTop: '24px'
  },
  underline: {
    '&::before': {
      borderColor: 'rgba(0, 0, 0, 0.42)'
    }
  },
  error: {
    color: 'red'
  },
  input: {
    fontSize: '14px',
    color: '#545455',
    position: ''
  },
  shrink: {
    color: '#6F6F8C',
    fontSize: '12px'
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '30px',
    width: '22%',
    justifyContent: 'space-between',
    marginLeft: 'auto',
    marginTop: '22px',
    marginBottom: '22px'
  },
  buttons: {
    marginLeft: '10px',
    padding: '0px 5px'
  },
  button: {
    width: '150px',
    height: '36px',
    textTransform: 'capitalize',
    margin: 0
  },
  hr: {
    marginTop: '100px',
    borderColor: '#D8DCDE',
  },
  graphCardWrapper: {
    width: '100%',
    height: '200px'
  },
  cardContainer: {
    borderRadius: '5px',
    border: '1px solid #70707033',
  },
  gridContainer: {
    padding: '15px',
  },
  cardText: {
    color: '#6F6F6F',
    fontSize: '14px',
    opacity: '60%'
  },
  cardValue: {
    color: '#6F6F6F',
    fontSize: '14px',
    wordBreak: 'break-word',
    fontWeight: 600
  },
  graphHeaderWrapper: {
    backgroundColor: '#F7F7F7',
    padding: '0.5rem',
    color: '#F37320',
    fontWeight: 'bold'
  },
  smallerFont: {
    fontSize: '14px',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    float: 'right',
    cursor: 'pointer'
  },
  iconTitle: {
    marginRight: '20px'
  },
  unselected: {
    color: '#6F6F6F',
    opacity: '60%'
  },
  staticMargin: {
    minWidth: '100px',
  },
  calendarContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  calendarAlignment: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  arrowIcon: {
    fontFamily: 'Material Icons, serif',
    fontStyle: 'normal',
    fontSize: '40px',
    display: 'inline-block',
    color: '#6F6F6F',
    cursor: 'pointer'
  },
  link: {
    color: '#026AE3',
    cursor: 'pointer'
  },
  dataContainer: {
    border: '1px solid #DEDEDE',
    borderRadius: '5px',
    padding: '10px'
  },
  heading: {
    color: '#565657',
    fontSize: '16px',
    fontWeight: 'bold'
  },
  subHeading: {
    fontSize: '12px',
    fontWeight: 'bold'
  },
  content: {
    fontSize: '12px'
  },
  icons: {
    width: 12,
    verticalAlign: 'middle',
  },
  batteryIcon: {
    width: 20,
    margin: '3px 0'
  },
  gridModalText: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#565657'
  },
  modalButton: {
    margin: '10px 10px 0',
    height: '40px'
  },
  switchLabel: {
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#000',
      opacity: 0.3
    }
  },
  production: {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#2768F6',
    }
  },
  consumption: {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#F09035',
    }
  },
  importExport: {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: COLOR.imported,
    }
  },
  battery: {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#3A845D',
    }
  },
  switchWrapper: {
    flexDirection: 'row !important',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: 'auto',

    '@media (min-width: 1024px)': {
      width: '75%'
    },

    '@media (min-width: 1440px)': {
      width: '50%'
    },


    '& .MuiFormControlLabel-root': {
      marginRight: '0px',
      marginLeft: '0px',
    },

    '& .MuiFormControlLabel-label': {
      textTransform: 'capitalize',
      color: '#545455',
      fontSize: '14px'
    },
  },
  displaySwitch: {
    display: 'contents'
  },
  graphWrapper: {
    height: 'calc(18vh + 50px)',
    position: 'relative',
    cursor: 'pointer',

    '& .rv-xy-plot__axis__tick__line': {
      display: 'none'
    },

    '& .rv-xy-plot__axis__title': {
      fontFamily: 'Roboto',
      fontSize: '10px',
      fontWeight: 'bold',
      color: '#7b8793',
      transform: 'translate(40px, -37.5px) rotate(90deg)'
    }
  },
  graphContainer: {
    position: 'relative',

    '& #rect-series': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'transparent'
    }
  },
  batteryGraphWrapper: {
    height: '12vh',
    position: 'relative',
    cursor: 'pointer'
  },
  batteryCrossHair: {
    '& .rv-crosshair__inner__content': {
      display: 'none'
    },

    '& .rv-crosshair__inner': {
      display: 'none'
    }
  },
  negativeCrossHair: {
    '& .rv-crosshair__inner__content': {
      display: 'none'
    },

    '& .rv-crosshair__inner': {
      display: 'none'
    }
  },
  positveCrossHair: {
    top: 0,
  },
  CrossHairCard: {
    width: '150px',
    padding: '5px 10px 5px',

    background: '#ffffff',
    color: '#000000',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.09)',
    border: '1px solid #d7dbde',
    borderRadius: '8px',
    position: 'absolute',
    right: '2%',
    top: '20px',
    margin: '0 10px',
  },
  crossHairTextWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '5px',

    '& p': {
      fontSize: '12px'
    }
  },
  produced: {
    '& p': {
      color: COLOR.produced
    }
  },
  consumed: {
    '& p': {
      color: COLOR.consumed
    }
  },
  importedExported: {
    '& p': {
      color: COLOR.exported
    }
  },
  chargeText: {
    '& p': {
      color: COLOR.charge
    }
  },
  border: {
    borderBottom: '1px solid RGB(84, 84, 86, 0.5)',
    paddingBottom: '10px'
  },
  cardHeading: {
    fontFamily: 'Roboto',
    fontSize: '10px',
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.5px',
    color: 'rgba(123, 135, 147, 0.8)',
    marginBottom: '12px',
    marginTop: '10px',
    textTransform: 'uppercase',
    textAlign: 'right'
  },
  units: {
    fontSize: '10px',
    marginLeft: '2px'
  },
  hide: {
    display: 'none'
  },
  eventName: {
    '& button': {
      marginLeft: '10%'
    }
  },
  tagsContainer: {
    maxHeight: '180px',
    overflowY: 'auto'
  },
  bottomCircle: {
    color: '#565657',
    opacity: 0.3,
  },
  circleRoot: {
    position: 'absolute',
    left: 0,
    color: '#00B300'
  },
  applicationStatusKey: {
    color: '#6F6F6F',
    opacity: '60%',
    fontSize: '12px',
  },
  applicationStatus: {
    backgroundColor: '#F7F7F7',
    color: '#545455',
    marginTop: "20px",
    borderRadius: '20px',
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'center'
  },
  popWrapper: {
    textAlign: 'center',
  },
  popupContentWrapper: {
    textAlign: 'left',
    padding: '0 12px'
  },
  popHeader: {
    color: '#545456',
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '16px'
  },
  popText: {
    color: '#545456',
    fontSize: '14px',
  },
  ackButton: {
    margin: '5px auto',
    width: '45%',
    height: '36px'
  },
  buttonGroup: {
    // width: '90%',
    margin: '20px auto 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  select: {
    '@media (min-width: 3000px)': {
      '& svg': {
        top: 'calc(50% - 25px)'
      }
    }
  },
  center: {
    textAlign: 'center'
  },
  labelWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dateRangeWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  typeWrapper: {
    height: '47.5px',
    display: 'flex',
    alignItems: 'center',
  },
  dateRange: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  dateRangeContent: {
    paddingLeft: '10px'
  },
  calendarWrapper: {
    position: 'relative',
    width: '130%',
    right: '30%',
    top: '10%',
    '& .react-calendar__tile--now': {
      background: 'transparent'
    },
    '& .react-calendar__tile--active': {
      background: '#F37321',
      color: 'white'
    },
    '& .react-calendar__tile--hasActive': {
      background: '#F37321',
      color: 'white'
    },
    '& .react-calendar__tile--active.react-calendar__tile--now': {
      background: '#F37321',
      color: 'white'
    },
    '& react-calendar__tile--now. react-calendar__tile--hasActive': {
      background: '#F37321',
      color: 'white'
    },
    '& .react-calendar__tile--active.react-calendar__tile--now.react-calendar__tile--hasActive': {
      background: '#F37321',
      color: 'white'
    },
    '& .react-calendar__tile--active.react-calendar__tile--now.react-calendar__tile:enabled:hover': {
      background: '#F37321',
      color: 'white'
    },
    '& .react-calendar__tile--active.react-calendar__month-view__days__day--weekend': {
      background: '#F37321',
      color: 'white'
    },
    '& .react-calendar__month-view__days__day--weekend': {
      color: 'revert'
    },
    '& .react-calendar__tile:enabled:hover': {
      background: 'unset'
    },
    '& .react-calendar__tile:enabled:focus': {
      background: '#F37321',
      color: 'white'
    },
    '& .react-calendar__tile--hasActive:enabled:hover': {
      background: '#F37321',
      color: 'white'
    },
    '& .react-calendar__tile--hasActive:enabled:focus': {
      background: '#F37321',
      color: 'white'
    },
    '& .react-calendar__tile--active:enabled:hover': {
      background: '#F37321',
      color: 'white'
    },
    '& .react-calendar__tile--active:enabled:focus': {
      background: '#F37321',
      color: 'white'
    },
    '& .react-calendar__navigation button': {
      minWidth: '15px',
      fontWeight: 'bold'
    },
    '& .react-calendar__navigation button:enabled:hover': {
      backgroundColor: 'unset'
    },
    '& .react-calendar__navigation button:disabled': {
      visibility: 'hidden'
    },
    '& .react-calendar__navigation button:enabled:focus': {
      backgroundColor: 'unset'
    },
    '& .react-calendar__month-view__weekdays': {
      textTransform: 'none',
      fontWeight: 'normal'
    },
    '& .react-calendar__month-view__days__day--neighboringMonth.react-calendar__month-view__days__day--weekend': {
      color: '#757575'
    },
    '& .react-calendar__tile:disabled.react-calendar__month-view__days__day--neighboringMonth': {
      color: 'rgba(16, 16, 16, 0.3)'
    },
    '& .react-calendar__year-view .react-calendar__tile': {
      padding: '10px',
      marginBottom: '10px'
    },
    '& .react-calendar__decade-view .react-calendar__tile': {
      padding: '9px',
      marginBottom: '10px'
    },
    '& .react-calendar__century-view .react-calendar__tile': {
      padding: '9px',
      marginBottom: '10px'
    },
    '& .react-calendar__tile:disabled': {
      background: 'unset',
      color: 'rgba(16, 16, 16, 0.3)'
    }
  },
  calendar: {
    position: 'absolute',
    zIndex: '2',
    background: '#FFFFFF',
    boxShadow: '0px 2px 16px #212B3614',
    borderColor: '#FFFFFF',
    borderRadius: '4px',
    padding: '5px 10px 5px 10px'
  },
  crossHair: {
    zIndex: 2,
    position: 'absolute',

    '& .rv-crosshair__line': {
      background: 'rgba(123, 135, 147, 0.3)',
      width: '2px',
      height: '540px',

      '&::before': {
        content: "",
        position: 'absolute',
        top: 0,
        left: '-6px',
        borderColor: '#f7f8fc transparent transparent',
        borderStyle: 'solid',
        borderWidth: '8px 6px 0',
        filter: 'drop-shadow(0 0 1px #9d9d9d)'
      },

      '&::after': {
        content: "",
        position: 'absolute',
        bottom: 0,
        left: '-6px',
        borderColor: 'transparent transparent #f7f8fc',
        borderStyle: 'solid',
        borderWidth: '0 6px 8px',
        filter: 'drop-shadow(0 0 1px #9d9d9d)'
      }
    },

    '& .rv-crosshair__inner': {
      marginRight: '2px',
      zIndex: 2,

      '&::before': {
        content: "",
        position: 'absolute',
        top: '10px',
        right: '-5px',
        borderColor: 'transparent transparent transparent #d5dadd',
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 5px'
      },

      '&::after': {
        content: "",
        position: 'absolute',
        top: '10px',
        right: '-4px',
        borderColor: 'transparent transparent transparent #ffffff',
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 5px'
      }
    },

    '& .rv-crosshair__inner--right': {
      '& .custom-hintbox': {
        left: '2%',
      }
    },

    '& .rv-crosshair__inner--left': {
      '& .custom-hintbox': {
        right: '2%',
      }
    },
  },
  selectWrapper: {
    display: 'flex',
    width: 'fit-content',
    alignItems: 'center'
  },
  sortTitle: {
    fontSize: '14px',
    color: '#6F6F6F',
    paddingRight: '9px'
  },
  dropDownRoot: {
    padding: '5px 32px 5px 10px'
  },
  disabledArrow: {
    color: '#6F6F6F',
    opacity: '20%',
    cursor: 'not-allowed'
  }
}))

export { useStyles }